import React, { useState, useEffect, useRef } from 'react';
import styles from './SubWorkspaceDetails.module.css';
import './allPages.css';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import {
  Tooltip,
  Dialog,
  TableContainer,
  Table,
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import RefreshIcon from '@mui/icons-material/Refresh';
import CloseIcon from '@mui/icons-material/Close';
import { formatDistanceToNow, parseISO } from 'date-fns';
import FetchData from './ServerCall/FetchData';
import {
  ConvertListOfListToDataConnectionRichTreeViewList,
  isNameAllowed,
} from './CommonFunctions/CommonFunctions';
import RichTreeViewControl from './Controls/RichTreeViewControl';
import { fontSize, palette } from '..';
import { NotificationDialog, PopUpSpinner } from './CommonFunctions/DialogComponents';
import { messages } from './CommonFunctions/aliases';
import {
  getContentDependencies,
  renameContent,
  deleteContent as _deleteContent,
} from '../api/workspace';
import { useWorkspace } from '../hooks/useWorkspace';
import { IWorkspace, TAlert } from '../types/types';
import { downloadFlatFile } from '../api/flatfile';
import Logger from '../Logger';
import { refreshDataset } from '../api';
import ScheduleRefresh from './ScheduleDataset/ScheduleRefresh';
import { AccessTime } from '@mui/icons-material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowDown';
import datasourceIcon from '../../src/assets/datasource.svg';
import webapiIcon from '../../src/assets/web_api.svg';

interface SubWorkspace {
  id: string;
  name: string;
  contentType: number;
  modified: any;
  type: any;
  createdAt: any;
  updatedAt: any;
}

const SubWorkspaceDetails = () => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editContentId, setEditContentId] = useState(null);
  const [hoveredRowId, setHoveredRowId] = useState<string | null>(null);
  const [workspaceName, setWorkspaceName] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState('');
  const [_loading, setLoading] = useState(false);
  const [alert, setAlert] = useState<null | TAlert>(null);
  const { parentId } = useParams();
  const [dataset, setDataset] = useState<string | null>(null);
  const [dsInfo, setdsInfo] = useState<{
    id: string;
    name: string;
    refreshed: string;
  } | null>(null);
  const [parentWorkspaceName, setParentWorkspaceName] = useState('');
  const [childWorkspaceName, setChildWorkspaceName] = useState('');
  // const [ownerName, setOwnerName] = useState('');
  const navigate = useNavigate();
  const [mode] = useState('New');
  const [selectedSubworkspaces, setSelectedSubworkspaces] = useState<string[]>([]);
  const [dependencyLoading, setDependencyLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState(''); // State for search input
  const [selectedFilter, setSelectedFilter] = useState('');
  const [filterOptions, setFilterOptions] = useState({
    dbconnection: false,
    webapi: false,
    dataset: false,
    flatfile: false,
    playbook: false,
  });
  const [tooltipText, setTooltipText] = useState('Filter Contents');
  const [selectedIconSrc, setSelectedIconSrc] = useState('');
  const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const [placeholder, setPlaceholder] = useState('Search All');
  const [sortConfig, setSortConfig] = useState({
    key: 'name',
    direction: 'asc',
  }); // state for sorting
  const [showContentDeleteConfirmation, setShowContentDeleteConfirmation] = useState(false);
  const [selectedContent, setSelectedContent] = useState<IWorkspace | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState<any>(null);
  const [selectedWorkSpaceItem, setSelectedWorkSpaceItem] = useState<any>({});
  const [showDependencyPopup, setShowDependencyPopup] = useState(false);
  const [dependencyData, setDependencyData] = useState<Array<Object>>([]);

  const [hideNewIcon, setHideNewIcon] = useState<boolean>(false);
  const [disableNewFlatfile, setDisableNewFlatfile] = useState<boolean>(false);
  const [disableNewDBConnection, setDisableNewDBConnection] = useState<boolean>(false);
  const [disableNewDataset, setDisableNewDataset] = useState<boolean>(false);
  const [disableNewPlaybook, setDisableNewPlaybook] = useState<boolean>(false);
  const id_parent = localStorage.getItem('parentId');

  const { result: contents, error, loading, refetch } = useWorkspace(parentId, true);
  const [refreshed, setRefreshed] = useState(false);
  const [scheduledRefresh, setScheduledRefresh] = useState(false);
  const [selectedDataset, setSelectedDataset] = useState<any>(null);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        if (isModalOpen) {
          setIsModalOpen(false);
          setErrorMessage('');
        }
        if (isEditModalOpen) {
          setIsEditModalOpen(false);
          setErrorMessage('');
        }
        if (showContentDeleteConfirmation) {
          setShowContentDeleteConfirmation(false);
          setSelectedContent(null);
        }
        if (showDependencyPopup) {
          setShowDependencyPopup(false);
          setDependencyData([]);
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isModalOpen, isEditModalOpen, showContentDeleteConfirmation, showDependencyPopup]);

  const openEditModal = (id: any, currentName: any, currentParentId: any, workspaceItem: any) => {
    setEditContentId(id);
    setWorkspaceName(currentName);
    // setParentId(currentParentId);
    setIsEditModalOpen(true);
    setSelectedWorkSpaceItem(workspaceItem);
  };
  const [flatFileDropDown, setFlatFileDropDown] = useState('');

  const location = useLocation();

  useEffect(() => {
    setChildWorkspaceName(location.state.childWorkspaceName);
    //eslint-disable-next-line
  }, []);

  const hideSubworkSpacePageIcons = (workSpace: any) => {
    setHideNewIcon(workSpace?.roleId === 7 || workSpace?.roleId === 0);

    if (workSpace?.roleId === 6) {
      if (
        workSpace.customPermissions?.find((item: any) => item.contentTypeId === 2)?.privilegeId ===
        1
      ) {
        setDisableNewDBConnection(false);
      } else {
        setDisableNewDBConnection(true);
      }
      if (
        workSpace.customPermissions?.find((item: any) => item.contentTypeId === 3)?.privilegeId ===
        1
      ) {
        setDisableNewDataset(false);
      } else {
        setDisableNewDataset(true);
      }
      if (
        workSpace.customPermissions?.find((item: any) => item.contentTypeId === 4)?.privilegeId ===
        1
      ) {
        setDisableNewFlatfile(false);
      } else {
        setDisableNewFlatfile(true);
      }
      if (
        workSpace.customPermissions?.find((item: any) => item.contentTypeId === 5)?.privilegeId ===
        1
      ) {
        setDisableNewPlaybook(false);
      } else {
        setDisableNewPlaybook(true);
      }
    }
  };

  const handleEditWorkspace = async () => {
    if (!selectedWorkSpaceItem || !editContentId) return;
    if (workspaceName.length > 40) return;
    const isValidName = isNameAllowed(workspaceName);

    if (!isValidName) {
      setErrorMessage(messages.workspace.wrongName);
      return;
    }

    try {
      setIsLoading(true);
      const response = await renameContent(
        selectedWorkSpaceItem.id,
        workspaceName,
        selectedWorkSpaceItem.parentWorkspaceId,
        selectedWorkSpaceItem.contentType,
      );
      if (response.isError) {
        setErrorMessage(response.message);
        return;
      } else {
        refetch();
        setIsEditModalOpen(false);
        setWorkspaceName('');
        setEditContentId(null);
      }
    } catch (error) {
      console.error('Error updating workspace:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const deleteContent = async (item: any) => {
    if (item.contentType === 5) {
      // setIndexToDelete(item.id);
      setShowContentDeleteConfirmation(true);
      setSelectedContent(item);
    } else {
      try {
        setDependencyLoading(true);
        const getDependencies = await getContentDependencies(
          item.id,
          item.contentType,
          item.parentWorkspaceId,
        );
        setDependencyLoading(false);
        if (getDependencies.error) {
          setAlert({
            severity: 'error',
            message: 'Unable to fetch dependency',
          });
          return;
        }
        if (!getDependencies.hasDependency) {
          // setIndexToDelete(item.id);
          setShowContentDeleteConfirmation(true);
          setSelectedContent(item);
        } else {
          const treeViewDependency = ConvertListOfListToDataConnectionRichTreeViewList(
            getDependencies.dependencies,
            [2, 4].includes(item.contentType) ? 'dataset' : 'playbook',
          );
          setDependencyData(treeViewDependency);
          setSelectedContent(item);
          setShowDependencyPopup(true);
        }
      } catch (error) {
        setDependencyLoading(false);
      }
    }
  };

  const cancelDelete = () => {
    setShowContentDeleteConfirmation(false);
  };

  const handleDeleteContent = async () => {
    if (!parentId || !selectedContent) return;
    try {
      setIsLoading(true);
      setShowContentDeleteConfirmation(false);
      const response = await _deleteContent(
        selectedContent.id,
        parentId,
        selectedContent.contentType,
      );
      if (!response.isError) {
        refetch();
      } else {
        console.error(
          `Failed to delete ${getContentTypeLabel(selectedContent.contentType, selectedContent.isExtract, (selectedContent as any).resourceType)?.toUpperCase()}:`,
          response.message || 'Unknown error',
        );
      }
    } catch (error) {
      console.error(
        `Error deleting ${getContentTypeLabel(selectedContent.contentType, selectedContent.isExtract, (selectedContent as any).resourceType)?.toUpperCase()}:`,
        error,
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchParentWorkspaceName = async () => {
      if (parentId) {
        setIsLoading(true);
        try {
          const response = await FetchData({
            requestType: 'noData',
            method: 'GET',
            url: `workspace/${id_parent}`, // Assuming the URL is dynamically constructed
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          });

          // console.log("Parent Workspace Response:", response.data);

          const foundWorkspace = response.data.find((workspace: any) => workspace.id === parentId);

          hideSubworkSpacePageIcons(foundWorkspace);

          if (foundWorkspace) {
            setParentWorkspaceName(foundWorkspace.parentWorkspaceName);
            setChildWorkspaceName(foundWorkspace.name);
            // setOwnerName(foundWorkspace.createdBy);
          } else {
            console.error('Workspace not found');
          }
        } catch (error) {
          console.error('Error fetching parent workspace:', error);
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchParentWorkspaceName();
  }, [id_parent]);

  const isWebApi = (contentType: any, resourceType?: string) => {
    return contentType === 2 && resourceType === 'webapi';
  };

  const isCreateContentDisabled = (contentName: string) => {
    if (contentName === 'Flatfile') {
      return disableNewFlatfile;
    } else if (contentName === 'DB Connection' || contentName === 'Web API') {
      return disableNewDBConnection;
    } else if (contentName === 'Dataset') {
      return disableNewDataset;
    } else if (contentName === 'Playbook') {
      return disableNewPlaybook;
    }
  };

  const handleCreateItem = async () => {
    let url;
    let data;

    switch (modalType) {
      case 'Flatfile':
      case 'Playbook':
      case 'DB Connection':
      case 'Web API':
      case 'Dataset':
        url = 'content/create';
        data = { name: workspaceName };
        break;
      default:
        return;
    }

    try {
      setIsLoading(true);
      setIsModalOpen(false);
      const response = await FetchData({
        requestType: 'withData',
        method: 'POST',
        url: url,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
        data: data,
      });

      if (response.status) {
        // console.log(`${modalType} created successfully`);
        setWorkspaceName('');
      } else {
        console.error(`Failed to create ${modalType}:`, response.data?.detail || 'Unknown error');
      }
    } catch (error) {
      console.error(`Error creating ${modalType}:`, error);
    } finally {
      setIsLoading(false);
    }
  };

  const getImageSrc = (contentType: any, resourceType?: string) => {
    if (isWebApi(contentType, resourceType)) return webapiIcon;
    switch (contentType) {
      case 2:
        return '/database_icon.svg';
      case 3:
        return '/ds.svg';
      case 4:
        return '/flat_file_icon.svg';
      case 5:
        return '/playbook_icon.svg';
      case 7:
        return datasourceIcon;
      default:
        return ''; // Return a default image or an empty string if no match
    }
  };
  const getContentTypeLabel = (contentType: any, isExtract?: boolean, resourceType?: string) => {
    if (isWebApi(contentType, resourceType)) return 'webapi';

    switch (contentType) {
      case 1:
        return 'sub-workspace';
      case 2:
        return 'dbconnection';
      case 3:
        return isExtract ? 'dataset (Extract)' : 'dataset';
      case 4:
        return 'flatfile';
      case 5:
        return 'playbook';
      default:
        return 'unknown';
    }
  };
  const getContentTypeName = (contentType: any, resourceType?: string) => {
    if (isWebApi(contentType, resourceType)) return 'Web API';

    switch (contentType) {
      case 2:
        return 'DB Connection';
      case 3:
        return 'Data Set';
      case 4:
        return 'Flat File';
      case 5:
        return 'Playbook';
      default:
        return 'unknown';
    }
  };

  const navigateToPages = (name: string, isFlatFile: boolean = false) => {
    switch (name) {
      case 'DB Connection':
        navigate(`/newdataconnection/${parentId}`, {
          state: {
            mode: mode,
            parentId: parentId,
            childWorkspaceName: childWorkspaceName,
          },
        });
        break;
      case 'Dataset':
        navigate(`/newdataset/${parentId}`, {
          state: {
            mode: mode,
            parentId: parentId,
            workspaceName: parentWorkspaceName,
            childWorkspaceName: childWorkspaceName,
            isFlatFile: isFlatFile,
          },
        });
        break;
      case 'Playbook':
        navigate(`/playbook?workspaceId=${parentId}`, {
          state: {
            mode: mode,
            parentId: parentId,
            workspaceName: parentWorkspaceName,
            childWorkspaceName: childWorkspaceName,
          },
        });
        break;
      case 'Flatfile':
        navigate(`/flatfileupload/${parentId}`, {
          state: {
            mode: mode,
            parentId: parentId,
            workspaceName: parentWorkspaceName,
          },
        });
        break;

      case 'Web API':
        navigate(`/webapidatasource/${parentId}`, {
          state: {
            mode: mode,
            parentId: parentId,
            workspaceName: parentWorkspaceName,
          },
        });
        break;
      default:
        return;
    }
  };

  const navigateToEditPages = (content: IWorkspace) => {
    const item = content as any;
    switch (content.contentType) {
      case 2:
        if (item.resourceType === 'webapi') {
          navigate(`/webapidatasource/${parentId}/${content.id}?workspaceid=${parentId}`, {
            state: {
              mode: 'Edit',
              parentId: parentId,
              workspaceName: parentWorkspaceName,
              id: content.id,
            },
          });
        } else {
          navigate(`/dbconnection/${content.id}?workspaceid=${parentId}`, {
            state: {
              mode: 'Edit',
              parentId: parentId,
              workspaceName: parentWorkspaceName,
              id: content.id,
            },
          });
        }
        break;

      case 3:
        navigate(`/editdataset/${content.id}`, {
          state: {
            mode: 'Edit',
            parentId: parentId,
            workspaceName: parentWorkspaceName,
            dsId: content.id,
          },
        });
        break;
      case 4:
        navigate(`/editflatfile/${parentId}`, {
          state: {
            mode: 'Edit',
            parentId: parentId,
            workspaceName: parentWorkspaceName,
            file: content,
          },
        });
        break;
      case 5:
        navigate(`/playbook?workspaceId=${parentId}&playbookId=${content.id}`, {
          state: {
            mode: 'Edit',
            workspaceName: parentWorkspaceName,
          },
        });
        break;
    }
  };

  const handleWorkspaceSelection = (id: string) => {
    if (selectedSubworkspaces.includes(id)) {
      // If already selected, remove it from the list
      setSelectedSubworkspaces(selectedSubworkspaces.filter((workspaceId) => workspaceId !== id));
    } else {
      // Otherwise, add it to the list
      setSelectedSubworkspaces([...selectedSubworkspaces, id]);
    }
  };

  // Select All function
  const selectAllWorkspaces = () => {
    const allWorkspaceIds = contents.map((workspace: any) => workspace.id);
    setSelectedSubworkspaces(allWorkspaceIds);
  };

  useEffect(() => {
    setFilterOptions({
      dbconnection: contents.some(
        (item: any) => item.contentType === 2 && !isWebApi(item.contentType, item.resourceType),
      ),
      webapi: contents.some((item: any) => isWebApi(item.contentType, item.resourceType)),
      dataset: contents.some((item: any) => item.contentType === 3),
      flatfile: contents.some((item: any) => item.contentType === 4),
      playbook: contents.some((item: any) => item.contentType === 5),
    });
  }, [contents]);

  const filteredWorkspaces = React.useMemo(() => {
    return contents.filter((workspace: any) => {
      const matchesSearch = workspace.name.toLowerCase().includes(searchQuery.toLowerCase());
      if (!selectedFilter) {
        return matchesSearch;
      }
      let matchesFilter = false;
      if (selectedFilter === 'webapi') {
        matchesFilter = isWebApi(workspace.contentType, (workspace as any).resourceType);
      } else if (selectedFilter === 'dbconnection') {
        // Show Only standard DB connections here
        matchesFilter =
          workspace.contentType === 2 &&
          !isWebApi(workspace.contentType, (workspace as any).resourceType);
      } else {
        matchesFilter =
          getContentTypeLabel(workspace.contentType) ===
          selectedFilter; /** do not pass extract as we want to filter all datasets both extract or non extract */
      }

      return matchesSearch && matchesFilter;
    });
  }, [contents, searchQuery, selectedFilter]);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  const handleFilterChange = (selectedValue: any) => {
    setSelectedFilter(selectedValue);
    let contentType;
    let resourceType;

    switch (selectedValue) {
      case 'sub-workspace':
        setPlaceholder('Search Workspaces');
        setTooltipText('Filtered by Workspaces');
        contentType = 1;
        break;
      case 'dbconnection':
        setPlaceholder('Search Databases');
        setTooltipText('Filtered by Databases');
        contentType = 2;
        break;
      case 'webapi':
        setPlaceholder('Search Web APIs');
        setTooltipText('Filtered by Web APIs');
        contentType = 2;
        resourceType = 'webapi';
        break;
      case 'dataset':
        setPlaceholder('Search Datasets');
        setTooltipText('Filtered Datasets');
        contentType = 3;
        break;
      case 'flatfile':
        setPlaceholder('Search Flatfiles');
        setTooltipText('Filtered Flatfiles');
        contentType = 4;
        break;
      case 'playbook':
        setPlaceholder('Search Playbooks');
        setTooltipText('Filtered Playbooks');
        contentType = 5;
        break;
      default:
        setPlaceholder('Search All');
        setTooltipText('Filter Contents');
        break;
    }
    const iconSrc = getImageSrc(contentType, resourceType);
    setSelectedIconSrc(iconSrc);
    setIsFilterDropdownOpen(false);
  };
  const handleClick = async (option: 'refresh' | 'info' | 'scheduledRefresh', id: string) => {
    if (option === 'scheduledRefresh') {
      const info = sortedAndFilteredWorkspaces.find((content) => content.id === id);
      if (!info) return;
      setSelectedDataset({
        workspaceId: parentId,
        datasetId: info.id,
      });
      setScheduledRefresh(true);
      return;
    }
    if (option === 'refresh') {
      setLoading(true);
      const res = await refreshDataset(id, parentId ?? '');
      if (res.isError)
        setAlert({
          severity: 'error',
          message: res.message,
        });
      else setRefreshed(true);
      setLoading(false);
    } else {
      const info = sortedAndFilteredWorkspaces.find((content) => content.id === id);
      if (!info) return;
      setdsInfo({
        id: info.id,
        name: info.name,
        refreshed: info.refreshedAt ?? '',
      });
    }
  };
  const openAccessModal = (workspaceId: any) => {
    // navigate(`/content/access/${parentId}`, { state: { workspaceId } });
    navigate(`/content/access/${workspaceId}`, { state: { parentId } });
  };

  const toggleFilterDropdown = () => {
    setIsFilterDropdownOpen(!isFilterDropdownOpen);
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsFilterDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleSort = (key: any) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const sortedAndFilteredWorkspaces = React.useMemo(() => {
    let sortedItems = [...filteredWorkspaces];

    if (sortConfig.key) {
      sortedItems.sort((a, b) => {
        let aValue, bValue;

        if (sortConfig.key === 'name') {
          aValue = a.name ? a.name.toLowerCase() : '';
          bValue = b.name ? b.name.toLowerCase() : '';
        } else if (sortConfig.key === 'type') {
          aValue = getContentTypeLabel(a.contentType, a.isExtract, (a as any).resourceType) || '';
          bValue = getContentTypeLabel(b.contentType, b.isExtract, (b as any).resourceType) || '';
        } else if (sortConfig.key === 'modified' || sortConfig.key === 'createdAt') {
          const aDate = a.updatedAt
            ? parseISO(a.updatedAt)
            : a.createdAt
              ? parseISO(a.createdAt)
              : new Date(0);
          const bDate = b.updatedAt
            ? parseISO(b.updatedAt)
            : b.createdAt
              ? parseISO(b.createdAt)
              : new Date(0);

          aValue = aDate.getTime();
          bValue = bDate.getTime();
        } else {
          return 0;
        }

        if (aValue < bValue) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    return sortedItems;
  }, [filteredWorkspaces, sortConfig]);

  const getSortIcon = (key: any) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'asc' ? (
        <img className="headerIcon-up" src="/sort-up.png" alt="Ascending" />
      ) : (
        <img className="headerIcon-down" src="/sort-down.png" alt="Descending" />
      );
    }
    return <img className="headerIcon" src="/sort.png" alt="Default" />;
  };

  const openMoreOptions = (id: string, isDataset: boolean) => {
    if (!isDataset) setFlatFileDropDown(id);
    else setDataset(id);
  };
  const closeMoreOptions = (isDataset: boolean) => {
    if (isDataset) setDataset(null);
    else setFlatFileDropDown('');
  };

  const handleDownload = async (flatFileId: string) => {
    try {
      const id = flatFileId.split(' ')[0];
      const fileName = flatFileId.split(' ')[1];
      const result = await downloadFlatFile(id);

      if (!result.isError && result.data) {
        const blob = new Blob([result.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = `${fileName}.csv`;
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        Logger('info', 'Error downloading file:');
        return {
          success: false,
          errorMessage: result.message,
        };
      }
    } catch (error) {
      Logger('error', 'File Download exception', error);
      return {
        success: false,
        errorMessage: 'An unexpected error occurred while downloading file',
      };
    }
  };

  const handleUpdateFlatFile = (flatFileId: string) => {
    const id = flatFileId.split(' ')[0];
    // const fileName = flatFileId.split(' ')[1];

    navigate(`/flatfileupload/${parentId}`, {
      state: {
        mode: 'update',
        parentId: parentId,
        fileId: id,
        workspaceName: parentWorkspaceName,
      },
    });
  };

  return (
    <React.Fragment>
      {showDependencyPopup ? (
        <RichTreeViewControl
          isWarning={true}
          list={dependencyData}
          showControls={false}
          showInPopup={true}
          handleCloseButtonClick={(e: any) => {
            setShowDependencyPopup(false);
            setSelectedContent(null);
          }}
          title={[`Can't delete ${selectedContent!.name}.`, 'Here is the list of dependencies.']}
          hasMultipleTitle={true}
        />
      ) : null}
      <div className={`${styles.subworkspaceContainer} subworkspace-container`}>
        <div className="sub-heading" style={{ height: '50px', border: '1px solid transparent' }}>
          <img src="/folder_work.svg" style={{ width: '24px', height: '24px' }} alt="Folder Icon" />
          <div>
            <h3
              style={{
                // marginTop: "-4px",
                // marginBottom: "5px",
                padding: '0px',
                margin: '0px',
                marginLeft: '6px',
                fontSize: fontSize.large,
                color: palette.primary.contrastText,
              }}
            >
              {childWorkspaceName}
            </h3>
          </div>
        </div>

        <div className="subworkspace-button-add-search-container">
          <div className="subworkspace-action-buttons">
            <div className={styles.dropdown}>
              {!hideNewIcon && !isLoading && (
                <button className={`${styles.createWorkspace} create-workspace`}>
                  <img
                    className="addIcon addIconDefault"
                    src="/add_green.png"
                    alt="Add Users Logo"
                    style={{
                      width: '16px',
                      height: '16px',
                      fontSize: fontSize.medium,
                    }}
                  />
                  &nbsp;New
                </button>
              )}
              <div className={styles.dropdownContent}>
                {[
                  { name: 'Data Source', icon: getImageSrc(7) },
                  { name: 'Dataset', icon: getImageSrc(3) },
                  { name: 'Playbook', icon: getImageSrc(5) },
                ].map((item) =>
                  item.name === 'Data Source' ? (
                    <div className={styles.dropdownItem} key={item.name}>
                      <button
                        style={{
                          display: 'flex',
                          fontSize: fontSize.medium,
                          alignItems: 'center',
                          width: '100%',
                          justifyContent: 'space-between',
                          paddingRight: '10px',
                        }}
                        className={
                          isCreateContentDisabled('Flatfile') &&
                          isCreateContentDisabled('DB Connection')
                            ? styles.disabledOption
                            : ''
                        }
                      >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <img
                            src={item.icon}
                            alt={`${item.name} Icon`}
                            style={{
                              marginRight: '15px',
                              width: '17px',
                              height: '17px',
                            }}
                          />
                          {item.name}
                        </div>
                        <KeyboardArrowRightIcon
                          sx={{ fontSize: 18, color: '#646161', flexShrink: 0 }}
                        />
                      </button>
                      <div className={styles.subDropdownContent}>
                        <button
                          style={{
                            display: 'flex',
                            fontSize: fontSize.medium,
                            alignItems: 'center',
                          }}
                          className={
                            isCreateContentDisabled('Flatfile') ? styles.disabledOption : ''
                          }
                          onClick={() => navigateToPages('Flatfile')}
                        >
                          <img
                            src={getImageSrc(4)}
                            alt="Flat File Icon"
                            style={{
                              marginRight: '15px',
                              width: '17px',
                              height: '17px',
                            }}
                          />
                          Flat File
                        </button>
                        <button
                          style={{
                            display: 'flex',
                            fontSize: fontSize.medium,
                            alignItems: 'center',
                          }}
                          className={
                            isCreateContentDisabled('DB Connection') ? styles.disabledOption : ''
                          }
                          onClick={() => navigateToPages('DB Connection')}
                        >
                          <img
                            src={getImageSrc(2)}
                            alt="DB Connection Icon"
                            style={{
                              marginRight: '15px',
                              width: '17px',
                              height: '17px',
                            }}
                          />
                          DB Connection
                        </button>
                        <button
                          style={{
                            display: 'flex',
                            fontSize: fontSize.medium,
                            alignItems: 'center',
                          }}
                          onClick={() => navigateToPages('Web API')}
                        >
                          <img
                            src={getImageSrc(2, 'webapi')}
                            alt="Web API Icon"
                            style={{
                              marginRight: '15px',
                              width: '17px',
                              height: '17px',
                            }}
                          />
                          Web API
                        </button>
                      </div>
                    </div>
                  ) : (
                    <button
                      key={item.name}
                      style={{
                        display: 'flex',
                        fontSize: fontSize.medium,
                        alignItems: 'center',
                      }}
                      className={isCreateContentDisabled(item.name) ? styles.disabledOption : ''}
                      onClick={() => {
                        setModalType(item.name);
                        if (item.name === 'Workspace') {
                          setIsModalOpen(true);
                          return;
                        }
                        navigateToPages(item.name);
                      }}
                    >
                      <img
                        src={item.icon}
                        alt={`${item.name} Icon`}
                        style={{
                          marginRight: '15px',
                          width: '17px',
                          height: '17px',
                        }}
                      />
                      {item.name}
                    </button>
                  ),
                )}
              </div>
            </div>
          </div>

          <div className="subWorkspaceSelectActionContainer">
            <div className="subWorkspaceActionsContainer"></div>

            <div className={styles.SearchFilterContainer}>
              <div className={styles.filterDropdownContainer}>
                <div
                  className={styles.filterTooltipImgContainer}
                  ref={dropdownRef}
                  onClick={toggleFilterDropdown}
                  onBlur={() => setIsFilterDropdownOpen(false)}
                  onMouseOver={() => setIsFilterDropdownOpen(true)}
                  onMouseLeave={() => setIsFilterDropdownOpen(false)}
                >
                  <Tooltip
                    title={tooltipText}
                    placement="top"
                    slotProps={{
                      tooltip: {
                        sx: {
                          fontSize: '12px',
                        },
                      },
                    }}
                  >
                    {selectedFilter ? (
                      <img
                        src="/filter.png"
                        alt="Filter Icon"
                        style={{ cursor: 'pointer', marginTop: '3px' }}
                      />
                    ) : (
                      <img
                        src="/filter-outline.png"
                        alt="Filter Icon"
                        style={{ cursor: 'pointer', marginTop: '3px' }}
                      />
                    )}
                  </Tooltip>
                  {selectedFilter && selectedIconSrc && (
                    <img
                      src={selectedIconSrc}
                      alt="Selected Filter Icon"
                      style={{
                        marginLeft: '8px',
                        cursor: 'pointer',
                        width: '14px',
                        height: '14px',
                      }}
                    />
                  )}
                </div>
                {isFilterDropdownOpen && (
                  <div
                    className={styles.filterDropdown}
                    style={{ transform: 'translate(0,0)' }}
                    onMouseOver={() => setIsFilterDropdownOpen(true)}
                    onMouseLeave={() => setIsFilterDropdownOpen(false)}
                  >
                    <ul className={styles.filterDropdownContent}>
                      <li
                        onClick={() => handleFilterChange('')}
                        style={{
                          fontSize: fontSize.medium,
                          color: palette.primary.contrastText,
                        }}
                      >
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> All
                      </li>

                      <li
                        className={styles.dropdownItem}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          paddingRight: '10px',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                            cursor: 'default',
                          }}
                        >
                          <img src={getImageSrc(7)} alt="datasource" />
                          Data Source
                        </div>
                        <KeyboardArrowRightIcon
                          sx={{
                            fontSize: 18,
                            color: '#646161',
                            flexShrink: 0,
                          }}
                        />

                        <div
                          className={styles.subDropdownContent}
                          style={{
                            right: '100%',
                            left: 'auto',
                            marginRight: '2px',
                            paddingTop: '4px',
                            paddingBottom: '4px',
                            fontSize: fontSize.medium,
                          }}
                        >
                          <button
                            onClick={() => handleFilterChange('flatfile')}
                            className={!filterOptions.flatfile ? styles.disabledOption : ''}
                            style={{
                              fontSize: fontSize.medium,
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <img
                              src="/flat_file_icon.svg"
                              alt="flatfile"
                              style={{ width: '14px', marginRight: '10px' }}
                            />{' '}
                            Flatfile
                          </button>
                          <button
                            onClick={() => handleFilterChange('dbconnection')}
                            className={!filterOptions.dbconnection ? styles.disabledOption : ''}
                            style={{
                              fontSize: fontSize.medium,
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <img
                              src="/database_icon.svg"
                              alt="database"
                              style={{ width: '14px', marginRight: '10px' }}
                            />{' '}
                            Database
                          </button>
                          <button
                            onClick={() => handleFilterChange('webapi')}
                            className={!filterOptions.webapi ? styles.disabledOption : ''}
                            style={{
                              fontSize: fontSize.medium,
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <img src={getImageSrc(2, 'webapi')} alt="webapi" />
                            Web API
                          </button>
                        </div>
                      </li>

                      <li
                        style={{
                          fontSize: fontSize.medium,
                          color: palette.primary.contrastText,
                        }}
                        onClick={() => handleFilterChange('dataset')}
                        className={!filterOptions.dataset ? styles.disabledOption : ''}
                      >
                        {/* <SchemaIcon
                          style={{
                            marginRight: "18px",
                            transform: "translateY(2px)",
                            color: "#616164",
                            width: "14px",
                            height: "15px",
                          }}
                        ></SchemaIcon> */}
                        <img src="/ds.svg" alt="Dataset" />
                        Dataset
                      </li>

                      {/* <li
                        style={{
                          fontSize: fontSize.medium,
                          color: palette.primary.contrastText,
                        }}
                        onClick={() => handleFilterChange('flatfile')}
                        className={!filterOptions.flatfile ? styles.disabledOption : ''}
                      >
                        <img src="/flat_file_icon.svg" alt="flatfile" />
                        Flatfile
                      </li> */}

                      <li
                        style={{
                          fontSize: fontSize.medium,
                          color: palette.primary.contrastText,
                        }}
                        onClick={() => handleFilterChange('playbook')}
                        className={!filterOptions.playbook ? styles.disabledOption : ''}
                      >
                        <img src="/playbook_icon.svg" alt="playbook" />
                        Playbook
                      </li>
                    </ul>
                  </div>
                )}
              </div>

              <div className="subWorkspaceSearchContainer">
                <input
                  type="text"
                  className="subWorkspaceSearchInput"
                  value={searchQuery}
                  onChange={handleSearch}
                  placeholder={placeholder}
                  style={{
                    fontSize: fontSize.medium,
                    color: palette.primary.contrastText,
                  }}
                />
                <img src="/glass.png" alt="Search Icon" className="subWorkspaceSearchIcon" />
              </div>
            </div>
          </div>
        </div>

        {loading ? (
          <div className={styles.subLoadingContainer}>
            <div className={styles.spinner}></div>
          </div>
        ) : contents?.length === 0 && searchQuery.length === 0 ? (
          <div className="no-user-info">
            <p
              className="loading-default-text"
              style={{
                fontSize: fontSize.medium,
                color: palette.primary.contrastText,
              }}
            >
              No contents available.
            </p>
          </div>
        ) : (
          <TableContainer className="subworkspce-table-container">
            <Table className={`${styles.subWorkspaceTable} subWorkspace-table`}>
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell onClick={() => handleSort('name')}>
                    Name <span className="icon-wrapper">{getSortIcon('name')}</span>
                  </TableCell>
                  <TableCell onClick={() => handleSort('type')} className="responsive-type-cell">
                    Type <span className="icon-wrapper">{getSortIcon('type')}</span>
                  </TableCell>
                  <TableCell onClick={() => handleSort('modified')}>
                    Modified <span className="icon-wrapper">{getSortIcon('modified')}</span>
                  </TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>

              {/* <thead>
              <tr>
                <th style={{ width: "80px", paddingLeft: "60px" }}></th>
                <th style={{ paddingLeft: "50px" }}>Name</th>
                <th style={{ paddingLeft: "50px" }}>Type</th>
                <th style={{ paddingLeft: "50px" }}>Modified</th>
              </tr>
            </thead> */}
              <TableBody>
                {!sortedAndFilteredWorkspaces ? (
                  <></>
                ) : sortedAndFilteredWorkspaces?.length > 0 ? (
                  sortedAndFilteredWorkspaces.map((workspace: any, index: any) => (
                    <TableRow
                      key={workspace.id}
                      onMouseEnter={() => setHoveredRowId(workspace.id)}
                      onMouseLeave={() => setHoveredRowId(null)}
                      className={selectedSubworkspaces.includes(workspace.id) ? 'selectedRow' : ''}
                    >
                      <TableCell>
                        {/* <input
                          type="checkbox"
                          checked={selectedSubworkspaces.includes(workspace.id)}
                          onChange={() =>
                            handleWorkspaceSelection(workspace.id)
                          }
                          style={{ width: "16px", height: "16px" }}
                        /> */}
                      </TableCell>

                      <TableCell>
                        {/* {workspace.contentType === 3 ? (
                          <SchemaIcon
                            style={{
                              color: "#616164",
                              width: "14px",
                              height: "15px",
                            }}
                          ></SchemaIcon>
                        ) : ( */}
                        <img
                          src={getImageSrc(workspace.contentType, (workspace as any).resourceType)}
                          alt=" "
                          style={{
                            width: '16px',
                            height: '16px',
                          }}
                        />
                        {/* )} */}
                      </TableCell>

                      <TableCell
                        style={{
                          fontSize: fontSize.medium,
                          color: palette.primary.contrastText,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          maxWidth: '9.5rem',
                          textDecoration: hoveredRowId === workspace.id ? 'underline' : '',
                          cursor: hoveredRowId === workspace.id ? 'pointer' : '',
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (hoveredRowId === workspace.id) {
                            navigateToEditPages(workspace);
                          }
                        }}
                      >
                        {workspace.name}
                      </TableCell>
                      <TableCell
                        className="responsive-type-cell"
                        style={{
                          fontSize: fontSize.medium,
                          color: palette.primary.contrastText,
                        }}
                      >
                        {getContentTypeLabel(
                          workspace.contentType,
                          workspace.isExtract,
                          (workspace as any).resourceType,
                        )}
                      </TableCell>

                      <TableCell
                        style={{
                          fontSize: fontSize.medium,
                          color: palette.primary.contrastText,
                        }}
                      >
                        {workspace.updatedAt || workspace.createdAt
                          ? formatDistanceToNow(
                              parseISO(workspace.updatedAt || workspace.createdAt),
                              { addSuffix: true },
                            )
                          : 'No date available'}
                      </TableCell>

                      <TableCell sx={{ position: 'relative', paddingRight: '2.5em' }}>
                        {workspace.roleId <= 8 && (
                          <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <div className="subworkspace-img-icon">
                              {workspace.contentType === 4 || workspace.isExtract ? (
                                <button
                                  onMouseEnter={() =>
                                    openMoreOptions(
                                      `${workspace.id} ${workspace.name}`,
                                      workspace.contentType === 3 && !!workspace.isExtract,
                                    )
                                  }
                                  onMouseLeave={() =>
                                    closeMoreOptions(
                                      workspace.contentType === 3 && !!workspace.isExtract,
                                    )
                                  }
                                  style={{
                                    background: 'none',
                                    border: 'none',
                                  }}
                                >
                                  <img
                                    src={
                                      hoveredRowId === workspace.id
                                        ? '/options.png'
                                        : '/options_grey.png'
                                    }
                                    alt="Options"
                                    style={{
                                      marginTop: '5px',
                                      width: '18px',
                                      height: '18px',
                                    }}
                                  />
                                </button>
                              ) : (
                                <div
                                  style={{
                                    width: '30px',
                                    height: '28px',
                                    padding: '1px 6px',
                                  }}
                                  about="placeholder"
                                ></div>
                              )}
                              {flatFileDropDown.split(' ')[0] === workspace.id && (
                                <div
                                  className={styles.flatFileDropDown}
                                  style={{ transform: 'translate(0,0)' }}
                                >
                                  <ul
                                    className={styles.flatFileDropDownContent}
                                    onMouseEnter={() =>
                                      openMoreOptions(`${workspace.id} ${workspace.name}`, false)
                                    }
                                    onMouseLeave={() => closeMoreOptions(false)}
                                    style={{
                                      fontSize: fontSize.extraSmall,
                                      color: palette.primary.contrastText,
                                    }}
                                  >
                                    <li
                                      onClick={() => handleDownload(flatFileDropDown)}
                                      className=""
                                      style={{
                                        color: 'gray',
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <img src="/download.png" alt="download" />
                                      Download as CSV
                                    </li>
                                    <li
                                      onClick={() => handleUpdateFlatFile(flatFileDropDown)}
                                      style={{
                                        color: 'gray',
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <img src="/reupload.png" alt="reupload" />
                                      Re-upload file
                                    </li>
                                    <li
                                      onClick={() => {
                                        closeMoreOptions(false);
                                        navigate(`/newdataset/${parentId}`, {
                                          state: {
                                            parentId,
                                            workspaceName: workspace.name,
                                            isFlatFile: true,
                                            flatfileId: workspace.id,
                                            openCurrentWorkspace: true,
                                          },
                                        });
                                      }}
                                      className=""
                                      style={{
                                        color: 'gray',
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <img
                                        src="/ds.svg"
                                        alt="dataset"
                                        style={{ filter: 'brightness(0)' }}
                                      />
                                      Create Data Set
                                    </li>
                                  </ul>
                                </div>
                              )}
                              {dataset && dataset?.split(' ')[0] === workspace.id && (
                                <Box
                                  className={styles.flatFileDropDown}
                                  sx={{ transform: 'translate(0,0)' }}
                                >
                                  <List
                                    onMouseEnter={() =>
                                      openMoreOptions(`${workspace.id} ${workspace.name}`, true)
                                    }
                                    onMouseLeave={() => closeMoreOptions(true)}
                                  >
                                    <ListItem disablePadding>
                                      <ListItemButton
                                        sx={{
                                          paddingBlock: 0,
                                          gap: '0.5rem',
                                        }}
                                        onClick={() => {
                                          handleClick('scheduledRefresh', workspace.id);
                                          console.log(workspace);
                                        }}
                                      >
                                        {/* <ListItemIcon> */}
                                        <AccessTime fontSize="small" />
                                        {/* </ListItemIcon> */}
                                        <ListItemText primary="Schedule Refresh" />
                                      </ListItemButton>
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemButton
                                        sx={{
                                          paddingBlock: 0,
                                          gap: '0.5rem',
                                        }}
                                        onClick={() => handleClick('refresh', workspace.id)}
                                      >
                                        {/* <ListItemIcon> */}
                                        <RefreshIcon fontSize="small" />
                                        {/* </ListItemIcon> */}
                                        <ListItemText primary="Refresh Extract" />
                                      </ListItemButton>
                                    </ListItem>
                                    <ListItem disablePadding>
                                      <ListItemButton
                                        onClick={() => handleClick('info', workspace.id)}
                                        sx={{
                                          paddingBlock: 0,
                                          gap: '0.5rem',
                                        }}
                                      >
                                        {/* <ListItemIcon> */}
                                        <InfoOutlineIcon fontSize="small" />
                                        {/* </ListItemIcon> */}
                                        <ListItemText primary="Refresh Info" />
                                      </ListItemButton>
                                    </ListItem>
                                  </List>
                                </Box>
                              )}
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigateToEditPages(workspace);
                                }}
                                style={{
                                  background: 'none',
                                  border: 'none',
                                }}
                              >
                                <Tooltip
                                  title="View / Edit "
                                  slotProps={{
                                    tooltip: {
                                      sx: {
                                        fontSize: '12px',
                                      },
                                    },
                                  }}
                                >
                                  <img
                                    src={
                                      hoveredRowId === workspace.id
                                        ? '/eye_purple.png'
                                        : '/eye_grey.png'
                                    }
                                    alt="Change"
                                    style={{
                                      marginTop: '5px',
                                      width: '20px',
                                      height: '20px',
                                    }}
                                  />
                                </Tooltip>
                              </button>

                              {
                                // workspace.contentType === 1 &&
                                // workspace.roleId < 5 ||
                                (workspace.levelId && workspace.levelId < 3) ||
                                workspace.roleId === 8 ? (
                                  <>
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        openEditModal(
                                          workspace.id,
                                          workspace.name,
                                          workspace.parentWorkspaceId,
                                          workspace,
                                        );
                                      }}
                                      style={{
                                        background: 'none',
                                        border: 'none',
                                      }}
                                    >
                                      <Tooltip
                                        title="Rename"
                                        slotProps={{
                                          tooltip: {
                                            sx: {
                                              fontSize: '12px',
                                            },
                                          },
                                        }}
                                      >
                                        <img
                                          src={
                                            hoveredRowId === workspace.id
                                              ? '/edit.png'
                                              : '/edit_grey.png'
                                          }
                                          alt="Edit"
                                          style={{
                                            width: '16px',
                                            height: '16px',
                                          }}
                                        />
                                      </Tooltip>
                                    </button>

                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        // handleDeleteWorkspace(workspace.id);
                                        // deleteWorkspace(workspace.id,workspace.name)
                                        if (workspace.contentType !== 1) {
                                          deleteContent(workspace);
                                        }
                                      }}
                                      style={{
                                        background: 'none',
                                        border: 'none',
                                      }}
                                    >
                                      <Tooltip
                                        title="Delete"
                                        slotProps={{
                                          tooltip: {
                                            sx: {
                                              fontSize: '12px',
                                            },
                                          },
                                        }}
                                      >
                                        <img
                                          src={
                                            hoveredRowId === workspace.id
                                              ? '/delete_red.png'
                                              : '/delete_grey.png'
                                          }
                                          alt="Delete"
                                          style={{
                                            width: '17px',
                                            height: '17px',
                                          }}
                                        />
                                      </Tooltip>
                                    </button>

                                    {workspace.roleId < 5 ? (
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          openAccessModal(workspace.id);
                                        }}
                                        style={{
                                          background: 'none',
                                          border: 'none',
                                        }}
                                      >
                                        <Tooltip
                                          title="Manage Access"
                                          slotProps={{
                                            tooltip: {
                                              sx: {
                                                fontSize: '12px',
                                              },
                                            },
                                          }}
                                        >
                                          <img
                                            src={
                                              hoveredRowId === workspace.id
                                                ? '/access.png'
                                                : '/access_grey.png'
                                            }
                                            alt="Access"
                                            style={{
                                              marginBottom: '-2.5px',
                                              width: '20px',
                                              height: '20px',
                                            }}
                                          />
                                        </Tooltip>
                                      </button>
                                    ) : (
                                      workspace.roleId !== 8 && (
                                        <button
                                          style={{
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'not-allowed',
                                          }}
                                        >
                                          <Tooltip
                                            title="Manage Access"
                                            slotProps={{
                                              tooltip: {
                                                sx: {
                                                  fontSize: '12px',
                                                },
                                              },
                                            }}
                                          >
                                            <img
                                              src={'/access_grey.png'}
                                              alt="Access"
                                              style={{
                                                marginBottom: '-2.5px',
                                                width: '20px',
                                                height: '20px',
                                                pointerEvents: 'none',
                                              }}
                                            />
                                          </Tooltip>
                                        </button>
                                      )
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <button
                                      style={{
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'not-allowed',
                                      }}
                                    >
                                      <Tooltip
                                        title="Rename"
                                        slotProps={{
                                          tooltip: {
                                            sx: {
                                              fontSize: '12px',
                                            },
                                          },
                                        }}
                                      >
                                        <img
                                          src={'/edit_grey.png'}
                                          alt="Edit"
                                          style={{
                                            width: '16px',
                                            height: '16px',
                                            pointerEvents: 'none',
                                          }}
                                        />
                                      </Tooltip>
                                    </button>

                                    <button
                                      style={{
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'not-allowed',
                                      }}
                                    >
                                      <Tooltip
                                        title="Delete"
                                        slotProps={{
                                          tooltip: {
                                            sx: {
                                              fontSize: '12px',
                                            },
                                          },
                                        }}
                                      >
                                        <img
                                          src={'/delete_grey.png'}
                                          alt="Delete"
                                          style={{
                                            width: '17px',
                                            height: '17px',
                                            pointerEvents: 'none',
                                          }}
                                        />
                                      </Tooltip>
                                    </button>

                                    {workspace.roleId !== 8 && (
                                      <button
                                        style={{
                                          background: 'none',
                                          border: 'none',
                                          cursor: 'not-allowed',
                                        }}
                                      >
                                        <Tooltip
                                          title="Manage Access"
                                          slotProps={{
                                            tooltip: {
                                              sx: {
                                                fontSize: '12px',
                                              },
                                            },
                                          }}
                                        >
                                          <img
                                            src={'/access_grey.png'}
                                            alt="Access"
                                            style={{
                                              marginBottom: '-2.5px',
                                              width: '20px',
                                              height: '20px',
                                              pointerEvents: 'none',
                                            }}
                                          />
                                        </Tooltip>
                                      </button>
                                    )}
                                  </>
                                )
                              }
                            </div>
                          </div>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableContainer className="no-user-info">
                    <p
                      className="loading-default-text"
                      style={{
                        fontSize: fontSize.medium,
                        color: palette.primary.contrastText,
                      }}
                    >
                      No content found.
                    </p>
                  </TableContainer>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        <PopUpSpinner show={dependencyLoading} />
        {/* Edit Workspace Modal  */}
        {isEditModalOpen ? (
          <div className={styles.subworkspaceModal}>
            <div className={styles.subworkspaceModalContent}>
              <h3
                style={{
                  fontSize: fontSize.large,
                  color: palette.primary.contrastText,
                }}
              >
                Rename
              </h3>
              <div
                className={styles.subworkspaceModalContentInput}
                style={{ height: errorMessage ? '30px' : '40px' }}
              >
                <input
                  type="text"
                  style={{
                    fontSize: fontSize.medium,
                    color: palette.primary.contrastText,
                    border: workspaceName.length > 40 ? '1px solid red' : '',
                  }}
                  value={workspaceName}
                  onChange={(e) => {
                    const value = e.target.value;
                    setWorkspaceName(value);

                    if (value.length > 40) {
                      setErrorMessage('Workspace name cannot exceed 40 characters.');
                    } else {
                      setErrorMessage('');
                    }
                  }}
                  placeholder="Workspace Name"
                />
              </div>
              <div className={styles.errorMessageContainer}>
                {errorMessage && (
                  <p style={{ color: 'red', fontSize: fontSize.small }}>{errorMessage}</p>
                )}
              </div>
              <div className={styles.subworkspaceModalButtons}>
                <button
                  className={styles.subworkspaceModalCancel}
                  onClick={() => {
                    setIsEditModalOpen(false);
                    setErrorMessage('');
                  }}
                  style={{ fontSize: fontSize.medium }}
                >
                  Cancel
                </button>
                <button
                  className={styles.workspaceSaveButton}
                  onClick={handleEditWorkspace}
                  style={{ fontSize: fontSize.medium }}
                >
                  Rename
                </button>
              </div>
            </div>
          </div>
        ) : null}

        {/* {isModalOpen && (
        <div className={styles.modal}>
          <div className={styles.modalContent}>
            <h3>Name your {modalType}</h3>
            <input
              type="text"
              required
              value={workspaceName}
              onChange={(e) => setWorkspaceName(e.target.value)}
              placeholder={`Enter ${modalType} name`}
            />
            <button className={styles.cancelButton} onClick={() => setIsModalOpen(false)}>Cancel</button>
            <button lassName={styles.saveButton} onClick={handleCreateItem}>Create</button>

          </div>
        </div>
      )}  */}

        <Dialog open={!!showContentDeleteConfirmation} onClose={cancelDelete}>
          {showContentDeleteConfirmation ? (
            <div className="workspace-remove-modal" style={{ height: 'auto' }}>
              <div className="workspace-remove-modalContent-close" style={{ visibility: 'hidden' }}>
                <Tooltip
                  title="Close"
                  slotProps={{
                    tooltip: {
                      sx: {
                        fontSize: '12px',
                      },
                    },
                  }}
                >
                  <CloseIcon
                    onClick={cancelDelete}
                    sx={{
                      fontSize: 'large',
                      color: '#545454',
                      cursor: 'pointer',
                      '&:hover': {
                        color: 'red',
                      },
                    }}
                  />
                </Tooltip>
              </div>

              <div className="workspace-remove-modalContent-p">
                <p
                  style={{
                    fontSize: fontSize.medium,
                    color: palette.primary.contrastText,
                  }}
                >
                  Are you sure you want to delete the{' '}
                  {getContentTypeName(
                    selectedContent!.contentType,
                    (selectedContent as any).resourceType,
                  )}{' '}
                  {selectedContent!.name}?
                </p>
              </div>

              <div className="workspace-modal-buttons">
                <button
                  onClick={cancelDelete}
                  className="workspace-modal-cancel"
                  style={{ fontSize: fontSize.medium }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleDeleteContent}
                  className="workspace-modal-confirm"
                  style={{ fontSize: fontSize.medium }}
                >
                  Confirm
                </button>
              </div>
            </div>
          ) : null}
        </Dialog>

        {isModalOpen && (
          <div className="modal">
            <div className="modal-content">
              <h3
                style={{
                  fontSize: fontSize.large,
                  color: palette.primary.contrastText,
                }}
              >
                Name your {modalType}
              </h3>
              <input
                type="text"
                required
                style={{
                  fontSize: fontSize.medium,
                  color: palette.primary.contrastText,
                }}
                // value={workspaceName}
                onChange={(e) => setWorkspaceName(e.target.value)}
                placeholder={`Enter ${modalType} name`}
              />
              {/* Error message section */}
              {/* {errorMessage && (
              <div className={styles.errorMessage}>
                {errorMessage}
              </div> 
            )} */}
              <div className="modal-buttons">
                <button
                  className="modal-cancel"
                  onClick={() => setIsModalOpen(false)}
                  style={{ fontSize: fontSize.medium }}
                >
                  Cancel
                </button>
                <button
                  className="modal-create"
                  onClick={handleCreateItem}
                  style={{ fontSize: fontSize.medium }}
                >
                  Create
                </button>
              </div>
            </div>
          </div>
        )}

        <ScheduleRefresh
          open={scheduledRefresh}
          setOpen={setScheduledRefresh}
          selectedDataset={selectedDataset}
        />

        {dsInfo && (
          <Dialog
            open={!!dsInfo}
            onClose={() => setdsInfo(null)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
          >
            <DialogTitle
              id="alert-dialog-title"
              sx={{
                fontSize: fontSize.large,
                fontWeight: '600',
              }}
            >
              Refresh Info
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <u>{dsInfo.name}</u> last refreshed{' '}
                <u>
                  {dsInfo.refreshed
                    ? formatDistanceToNow(parseISO(dsInfo.refreshed), {
                        addSuffix: true,
                      })
                    : 'No date available'}
                </u>
              </DialogContentText>
            </DialogContent>
          </Dialog>
        )}
        <PopUpSpinner
          show={_loading}
          paperProps={{
            sx: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            },
          }}
          text="Refreshing dataset"
        />
        {alert && (
          <NotificationDialog
            onCloseAlert={() => setAlert(null)}
            severity={alert.severity}
            testMessage={alert.message}
            openAlert={!!alert}
          />
        )}

        <Dialog
          open={refreshed}
          onClose={() => {
            refetch();
            setRefreshed(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              fontWeight: 'bold',
            }}
          >
            {'Dataset refresh'}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Dataset refreshed <b>successfully.</b>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                refetch();
                setRefreshed(false);
              }}
              autoFocus
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </React.Fragment>
  );
};

export default SubWorkspaceDetails;
